import { getPreferenceFromCache, setPreference } from "src/services/PreferenceStore";
import { InnerViewFilter, OneViewFilter, stringToView } from "../toLocalStorage";
import { getViews } from "./getViews";
import { stripViewFilterPrefix } from "./stripViewFilterPrefix";

type UpdateOptions = {
    gridKey: string;
    previousFilterName: string;
    viewToUpdate: OneViewFilter;
};
export const updateView = (options: UpdateOptions): OneViewFilter[] => {
    const { gridKey, previousFilterName, viewToUpdate } = options;
    const preferenceKey = stripViewFilterPrefix(gridKey);

    const allPreviousValues = getViews({ gridKey });
    const updatedFilters = allPreviousValues.reduce((acc, currentValue) => {
        if (previousFilterName === currentValue.filterName) {
            acc[viewToUpdate.filterName] = JSON.stringify({
                columnFilters: viewToUpdate.columnFilters,
                columnOrder: viewToUpdate.columnOrder,
                columnVisibility: viewToUpdate.columnVisibility,
            });
            return acc;
        }

        acc[currentValue.filterName] = JSON.stringify({
            columnFilters: currentValue.columnFilters,
            columnOrder: currentValue.columnOrder,
            columnVisibility: currentValue.columnVisibility,
        });
        return acc;
    }, {} as InnerViewFilter);

    const newFilterAsString = JSON.stringify(updatedFilters);

    setPreference("grid.views", preferenceKey, updatedFilters);

    if (previousFilterName !== viewToUpdate.filterName) {
        const currentOrder = getPreferenceFromCache<string[]>("grid.views.order", preferenceKey) ?? [];
        const updatedOrder = currentOrder.map((name) => (name === previousFilterName ? viewToUpdate.filterName : name));
        setPreference("grid.views.order", preferenceKey, updatedOrder);
    }

    const formattedOutput = stringToView(newFilterAsString);
    return formattedOutput;
};
